import { Card, CardBody, Col } from "reactstrap";
import { CustomRatioTitle } from "../../../Constants/Constants";
import { CustomRatioSubTitle } from "../../../Data/BonusUi/Ratios";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const CustomRatio = () => {
  return (
    <Col lg="6">
      <Card>
        <CommonCardHeader title={CustomRatioTitle} span={CustomRatioSubTitle} />
        <CardBody>
          <div className="ratio ratio-4x3">
            <iframe src="https://www.youtube.com/embed/AsZwvuUmHGU?si=LHExkFd586NQbVAG" title="YouTube video" allowFullScreen />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default CustomRatio;
